import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import guardAuthService from '../services/guardAuth.service';

interface PrivateRouteProps {
  children: React.ReactElement;
}

function PrivateRoute({ children }: PrivateRouteProps) {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  // SECURITY FIX: Auth bypass only works in development mode
  // Even if REACT_APP_BYPASS_AUTH is set, it's ignored in production builds
  const isDevelopment = import.meta.env.DEV;
  const bypassAuth = isDevelopment && import.meta.env.VITE_BYPASS_AUTH === 'true';

  if (bypassAuth) {
    return children;
  }

  // Check if we're handling a redirect with hash fragment
  const isHandlingRedirect = window.location.hash &&
    (window.location.hash.includes('id_token') ||
     window.location.hash.includes('access_token') ||
     window.location.hash.includes('code'));

  // Wait for authentication to complete or redirect handling
  if (inProgress === 'login' || inProgress === 'startup' || inProgress === 'handleRedirect' || isHandlingRedirect) {
    return <div>Loading...</div>;
  }

  // Guard passthrough: allow guard-authenticated users on /yard routes without MSAL
  if (guardAuthService.isAuthenticated() && location.pathname.startsWith('/yard')) {
    return children;
  }

  if (!isAuthenticated) {
    // Pass the current location so Login can redirect back after authentication
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default PrivateRoute;